<template>
  <!--单个商品组件（竖向排序，可换行）-->
  <tk-flex
    class="full-width"
    :class="{'closedCss': isInvalid}"
    style="position: relative;"
    @click.native="nextPage"
  >
    <div>
      <div
        class="class-recommended-img commodity-single-image"
        :style="{ width: imageSize + 'px' }"
      >
        <tk-image
          class="class-recommended-image"
          :src="commodity.showPictures[0]"
          :width="imageSize" :height="imageSize"></tk-image>
        <div v-if="isInvalid" class="closed-css-invalid">已失效</div>
      </div>
    </div>
    <tk-flex
      :style="{minHeight: imageSize + 'px'}"
      style="position: relative;"
      class="m-l-15 van-flex-row"
      column>
      <tk-flex
        middle
        class="full-width m-t-12"
      >
        <div
          style="width: 35px;flex-shrink:0;"
        >
          <tk-flex
            center
            v-if="commodity.selfAndSelected"
            style="line-height: 17px;"
            class="commodity-title-label">
            <div>
              {{commodity.selfAndSelected | titleLabel}}
            </div>
          </tk-flex>
        </div>
        <div class="font-14 van-ellipsis van-flex-row">{{commodity.productTitle}}</div>
      </tk-flex>
      <div
        v-if="!offerShow"
        class="m-t-5 item"
        style="position: absolute;bottom: 12px;"
      >
        <div v-if="commodity.oldPrice">
          <div class="class-card-red">
            <span class="font-10">￥</span>{{commodity.price}}
            <span class="font-12 m-l-10 class-card-decoration caption">
              <span class="font-10">￥</span>{{commodity.oldPrice}}
            </span>
          </div>
        </div>
        <div v-else>
          <div class="m-t-5 class-card-red">
            <span class="font-10">￥</span>{{commodity.price}}
          </div>
        </div>
      </div>
      <tk-flex column middle between class="full-width full-height m-b-12" style="flex:1" v-else>
        <div
          class="class-card-selling full-width class-card-ellipsis"
        >
          {{commodity.selling}}
        </div>
        <div v-if="commodity.oldPrice">
          <div class="m-t-10 class-card-red">
            <span class="font-10">￥</span>{{commodity.price}}
            <span class="font-12 m-l-10 class-card-decoration caption">
              <span class="font-10">￥</span>{{commodity.oldPrice}}
            </span>
          </div>
        </div>
        <div v-else>
          <div class="m-t-5 class-card-red">
            <span class="font-10">￥</span>{{commodity.price}}
          </div>
        </div>
        <div
          v-if="commodity.offerContent"
          class="m-t-5 font-12 class-card-wrap class-card-offer class-card-ellipsis"
        >{{commodity.offerContent}}</div>
      </tk-flex>
    </tk-flex>
  </tk-flex>
</template>

<script>
export default {
  data () {
    return {
      isInvalid: false // 是否失效
    }
  },
  props: {
    commodity: {
      type: Object
    },
    offerShow: {
      type: Boolean,
      default: true
    },
    imageSize: {
      type: Number,
      default: 130
    }
  },
  computed: {
    salesSum () {
      if (!this.commodity.sales) { return 0 }
      return this.commodity.sales
    }
  },
  filters: {
    titleLabel (val) {
      return val === 'self' ? '自营' : '精选'
    }
  },
  async mounted () {
    let status = await this.judgeId(this.commodity.objectId, 'commodity')
    this.isInvalid = !status || this.commodity.shelvesStatus === 'beenOffShelves'
  },
  methods: {
    nextPage () {
      if (this.isInvalid) { return }
      this.$push({ path: '/commodity/productDetails', query: { id: this.commodity.objectId } })
    }
  }
}
</script>

<style lang="scss" scoped>
  .class-card-red { /*颜色及文本修饰*/
    color: rgba(250, 51, 51, 1);
  }
  /*图片的修饰*/
  .commodity-single-image {
    border-radius: 5px;
    overflow: hidden;
    position: relative;
    .closed-css-invalid {
      position: absolute;
      top: 0;
      left: 0;
      padding: 3px;
      background-color: rgba(0, 0, 0, 0.1);
      font-size: 12px;
      color: #cecece;
    }
  }
  /*卖点样式*/
  .class-card-selling {
    min-height: 18px;
    border-radius: 2px;
    padding: 3px 0;
    font-size: 12px;
    color: rgba(153, 153, 153, 1);
  }
  /*优惠样式*/
  .class-card-offer {
    width: 100px;
    height: 20px;
    text-align: center;
    line-height: 19px;
    font-size: 12px;
    border: 1px solid rgba(255, 0, 0, 1);
    border-radius: 3px;
    color: rgba(255, 0, 0, 1);
  }
</style>
